import styled from 'styled-components';
import { flex } from '../../styles/mixins';

// Generic container
export const GenericCnt = styled.div`
  width: 100%;
  ${flex({ gap: '32px 0' })}
  gap: 32px;
`;
